import React, { useEffect, useRef, useState } from 'react';

import { useLoadBannerAd } from '@client/hooks';
import {
  BannerAdObj,
  featureManager,
  isAdnamiAd
} from '@schibsted-nmp/advertising-shared';

import { getState } from '../../../state/reducer';

type Props = {
  id: string;
  adObj: BannerAdObj;
  className: string;
};

// leaving it here until verified that it works
export const useIframeHeightForBanner = (
  initialHeight: number,
  ref: React.RefObject<HTMLDivElement>
) => {
  const [height, setHeight] = useState(initialHeight);

  useEffect(() => {
    const { initialState } = getState();

    let observer: MutationObserver | null = null;

    // check unleash features to see if iframe height on banners is enabled
    if (
      initialState?.unleash.features &&
      featureManager(
        initialState.unleash.features
      ).isIframeHeightOnBannersEnabled()
    ) {
      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && ref.current) {
            const firstIframe = ref.current.getElementsByTagName('iframe');
            if (firstIframe.length > 0) {
              const iframe = firstIframe[0];
              const iframeHeight = iframe.clientHeight;
              // Ensure iframeHeight is defined and greater than 0 before setting it
              if (typeof iframeHeight === 'number') {
                setHeight(iframeHeight < 0 ? 0 : iframeHeight);
              }
            }
          }
        });
      });

      if (ref.current) {
        observer.observe(ref.current, {
          attributes: true,
          childList: true,
          subtree: true
        });
      }
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [ref.current]); // Depend on ref.current to re-run if it changes

  return height;
};
export default function Banner(props: Props) {
  const { id, adObj, className } = props;
  const ref = useRef<HTMLDivElement>(null);

  const height = useIframeHeightForBanner(adObj ? adObj.height : 0, ref);
  // Ensure adObj.width is defined before using it, otherwise, set default values
  const bannerAdStyle = adObj ? { width: adObj.width, height } : {};

  useLoadBannerAd({ placementId: id, ref });

  return (
    <div
      style={bannerAdStyle}
      className={className}
      // Ensure adObj is defined before checking if it's an Adnami ad
      data-is-adnami={adObj ? isAdnamiAd(adObj) : false}
      ref={ref}
      id={id}
    />
  );
}
